import { DisplayAuditGroupByType } from "@Audit";
import { AuditGroupByTypes } from './audit.enums';


export const StorageKey_auditGroupBySettings = 'auditGroupBySettings';
export const AuditGroupByDisplayTypes: DisplayAuditGroupByType[] = [{displayName: 'None', apiValue: AuditGroupByTypes.None}, { displayName: 'Assigned To User', apiValue: AuditGroupByTypes.AssignedTo} , { displayName: 'Created By User', apiValue: AuditGroupByTypes.CreatedBy }, { displayName: 'Completed By User', apiValue: AuditGroupByTypes.CompletedBy }];
